import { Component, OnDestroy, OnInit } from "@angular/core";
import { TableLazyLoadEvent } from "primeng/table";
import { MedOptionType } from "@mk/med-ui";
import { Router } from "@angular/router";
import { HttpParams } from "@angular/common/http";
import { PAGINATION_OPTIONS } from "@app/components/supplies/supplies.component";
import { BasketService } from "@app/components/basket/basket.service";
import { DataService } from "@app/services/data.service";
import { MoneyUtil } from "@app/utils/money.util";
import { FilterService } from "@app/services/filter.service";
import { ReserveController } from "@app/ui_controllers/reserveController";
import { GoodSpecificationsResponse, ReserveGoodResponse } from "@app/ui_models/web-response";
import { DatePipe } from "@angular/common";
import { GoodsLovControlDateDto } from "@app/ui_models/model-dto";
import { MedNotificationService } from "@mk/med-notification";

@Component({
  selector: "app-reserves",
  templateUrl: "./reserves.component.html",
  styleUrls: ["./reserves.component.scss"],
})
export class ReservesComponent  implements OnInit, OnDestroy {

  constructor(private readonly router: Router,
              private readonly reserveController: ReserveController,
              private readonly notificationService: MedNotificationService,
              public dataService: DataService,
              public basketService: BasketService,
              public filter: FilterService,
  ) {

  }

  tableBodyReserveGoods:  ReserveGoodResponse[] = [];
  tabHeaderReserveGoods: { label: string; key: string; date: boolean; filter: boolean; joinTable: string; }[] = tabHeaderReserves;

  tableBodySpecifications:  GoodSpecificationsResponse [] = [];
  tabHeaderSpecifications: { label: string; key: string; date: boolean; filter: boolean; joinTable: string; showChevron: boolean; chevronOpen: boolean; hideAbleColumn: boolean; }[] = tabHeaderReservesSpecifications;

  rows = 0;
  totalRowsReserveGoods = 0;
  totalRowsSpecifications = 0;
  pageSize = 10;
  pageSizeSpecifications = 10;
  selectedPageNumber = 1;
  selectedPageNumberSpecifications = 1;
  sortOrder: number | undefined | null = null;
  filterActive = true;
  filterField: string | string[] | null | undefined = "";
  tableState: TableLazyLoadEvent = {};
  readonly paginationOptions: MedOptionType<number>[] = PAGINATION_OPTIONS;
  hideGroup1 = false;
  hideGroup2 = false;
  filtersSubscriber: any;

  optionsTabGroup: MedOptionType<any>[] = [
    {
      label: "Всі склади",
      value: 1,
    },
    {
      label: "Укрмедпостач",
      value: 2,
    },
    {
      label: "БЦФ",
      value: 3,
    },
  ];

  optionsModel = 1;
  showGoodsSpecifications = false;
  loadingCounter = 0;
  // @ts-ignore
  dateEditing = {};
  editingGoodsLovControlDateDto: GoodsLovControlDateDto = {} as GoodsLovControlDateDto;

  ngOnInit(): void {
    this.filtersSubscriber = this.filter.reservesSubject.subscribe(() => {
      if (this.showGoodsSpecifications) {
        this.getSpecifications(this.selectedPageNumber);
      } else {
        this.getGoods(this.selectedPageNumber);
      }
    });

    this.filter.reserves.controlDate = null;

    this.loadColumnOrder();
  }

  ngOnDestroy(): void {
    this.filtersSubscriber.unsubscribe();
  }

  saveColumnOrder() {
    localStorage.setItem("reserveColumnOrder", JSON.stringify(this.tabHeaderReserveGoods));
  }

  loadColumnOrder() {
    const savedOrder = localStorage.getItem("reserveColumnOrder");
    if (savedOrder) {
      this.tabHeaderReserveGoods = JSON.parse(savedOrder);
    }
  }

  loadData() {
    if (this.showGoodsSpecifications) {
      this.getSpecifications(this.selectedPageNumberSpecifications);
    } else {
      this.getGoods(this.selectedPageNumber);
    }
  }

  getGoods(
    page: number | undefined,
  ): void {
    let params = new HttpParams();
    this.selectedPageNumber = page ? page : 0;
    if (this.optionsModel !== 1) {
      params = params.append("conditions[0].fieldName", "supply_warehouseName");
      params = params.append("conditions[0].value", this.optionsModel === 2 ? "Укрмедпостач" : "БЦФ");
      params = params.append("conditions[0].operator", "EQUALS");
    }

    params = this.appendFilterParams(params);

    params = params.append("page", this.selectedPageNumber - 1);
    params = params.append("size", this.pageSize);

    // this.loadingCounter++;
    const timeoutId = setTimeout(() => {
      this.loadingCounter++;
    }, 300);

    this.reserveController.retrieveReserveGoods(params).subscribe(data => {
      this.tableBodyReserveGoods = data.content;
      this.totalRowsReserveGoods = data.totalElements;
      if (this.loadingCounter === 0) {
        clearTimeout(timeoutId);
      } else {
        this.loadingCounter--;
      }
    });
  }

  getSpecifications(
    page: number | undefined,
  ): void {
    let params = new HttpParams();
    this.selectedPageNumberSpecifications = page ? page : 0;
    if (this.optionsModel !== 1) {
      params = params.append("warehouseName", this.optionsModel === 2 ? "Укрмедпостач" : "БЦФ");
    }

    params = this.appendFilterParams(params);

    params = params.append("page", this.selectedPageNumberSpecifications - 1);
    params = params.append("size", this.pageSizeSpecifications);
    // params = params.append("sort", sortFieldAndOrder);

    // this.loadingCounter++;
    const timeoutId = setTimeout(() => {
      this.loadingCounter++;
    }, 300);
    this.reserveController.retrieveDistributionGoodsSpec(params).subscribe(data => {
      this.tableBodySpecifications = data.content;
      this.totalRowsSpecifications = data.totalElements;
      if (this.loadingCounter === 0) {
        clearTimeout(timeoutId);
      } else {
        this.loadingCounter--;
      }
    });

  }

  getPathStatusImg(rowElement: boolean): string {
    let color: string;
    if (!rowElement) {
      color = "red";
    } else {
      color = "green";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  pageChange(pageNumber: number) {
    this.selectedPageNumber = pageNumber;
    this.loadData();
  }

  pageChangeSpecifications(pageNumber: number) {
    this.selectedPageNumberSpecifications = pageNumber;
    this.loadData();
  }

  pageSizeChanged(pageSize: number) {
    this.pageSize = pageSize;
    this.selectedPageNumber = 1;
    this.loadData();
  }

  pageSizeChangedSpecifications(pageSize: number) {
    this.pageSizeSpecifications = pageSize;
    this.selectedPageNumberSpecifications = 1;
    this.loadData();
  }

  getFirstShowedRowIndex(): number {
    return this.selectedPageNumber === 1 ? 0 : (this.selectedPageNumber - 1) * this.pageSize;
  }

  getFirstShowedRowIndexSpecifications(): number {
    return this.selectedPageNumberSpecifications === 1 ? 0 : (this.selectedPageNumberSpecifications - 1) * this.pageSizeSpecifications;
  }

  goToDetails(id: string): void {
    this.router.navigate(["/availability/" + id]);
  }

  getRowSum(availableForDistribution: number, adjUnitPrice:number): string {
    return  MoneyUtil.toFixedTrunc(adjUnitPrice * availableForDistribution, 2);
  }

  tabGroupChanged(): void {
    this.selectedPageNumber = 1;
    this.getGoods(this.selectedPageNumber);
    this.getSpecifications(this.selectedPageNumber);
  }

  onChangeHandlerSpecification(row: GoodSpecificationsResponse): void {
    this.basketService.addIfNotExistsAndRemoveIfExists([row.specificationId], row.good.direction.id, row.warehouseName);
  }

  onChangeHandlerGood(row: ReserveGoodResponse): void {
    this.basketService.addIfNotExistsAndRemoveIfExists(row.specificationIds, row.direction.id, row.warehouseName);
  }

  showHidedColumns($event: MouseEvent, columnKey: string, hide: boolean): void {
    $event.preventDefault();
    $event.stopPropagation();
    if (columnKey === "2") {
      this.hideGroup1 = hide;
    } else if (columnKey === "17") {
      this.hideGroup2 = hide;
    }
  }

  filterHeader(tabHeaderSpecifications: {
        label: string;
        key: string;
        date: boolean;
        filter: boolean;
        joinTable: string;
        showChevron: boolean;
        chevronOpen: boolean;
        hideAbleColumn: boolean;
    }[]) {
    let filtered = tabHeaderSpecifications;
    let headersForFilter: string[] = [];
    if (this.hideGroup1) {
      headersForFilter = ["3", "4", "5", "6", "7", "8", "9"];
    }
    if (this.hideGroup2) {
      headersForFilter = headersForFilter.concat(["18", "19", "20", "21"]);
    }

    if (headersForFilter.length > 0) {
      filtered = tabHeaderSpecifications.filter(value => !headersForFilter.includes(value.key));
    }

    return filtered;
  }

  isVisibleFilters(): boolean {
    return this.filter.showReservesFilter;
  }

  viewChanged(): void {
    this.filter.goodSpecificationsShowed = this.showGoodsSpecifications;
    this.filter.showReservesFilter = false;
  }

  private appendFilterParams(params: HttpParams): HttpParams {
    if (this.showGoodsSpecifications) {
      return params;
    }
    const subscriber = this.filter.reservesSubject.subscribe(data => {
      let counter = 0;
      if (data.lovId.length) {
        params = params.append(`conditions[${counter}].fieldName`, "lovId");
        params = params.append(`conditions[${counter}].value`, data.lovId[0]);
        params = params.append(`conditions[${counter}].operator`, "EQUALS");
        counter++;
      }
      if (data.mnnId.length) {
        params = params.append(`conditions[${counter}].fieldName`, "mnnId");
        params = params.append(`conditions[${counter}].value`, data.mnnId[0]);
        params = params.append(`conditions[${counter}].operator`, "EQUALS");
        counter++;
      }
      if (data.direction.length) {
        params = params.append(`conditions[${counter}].fieldName`, "direction");
        params = params.append(`conditions[${counter}].values`, data.direction.join(", "));
        params = params.append(`conditions[${counter}].operator`, "IN");
        counter++;
      }
      if (data.mnn.length) {
        params = params.append(`conditions[${counter}].fieldName`, "mnnName");
        params = params.append(`conditions[${counter}].values`, data.mnn.join(", "));
        params = params.append(`conditions[${counter}].operator`, "IN");
        counter++;
      }

      if (data.dosage.length) {
        params = params.append(`conditions[${counter}].fieldName`, "dosage");
        params = params.append(`conditions[${counter}].value`, data.dosage[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.measure.length) {
        params = params.append(`conditions[${counter}].fieldName`, "unit");
        params = params.append(`conditions[${counter}].value`, data.measure[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.reject.length) {
        params = params.append(`conditions[${counter}].fieldName`, "releaseForm");
        params = params.append(`conditions[${counter}].value`, data.reject[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }
      if (data.availability.length) {
        params = params.append(`conditions[${counter}].fieldName`, "availableForDistribution");
        params = params.append(`conditions[${counter}].value`, data.availability[0]);
        params = params.append(`conditions[${counter}].operator`, "EQUALS");
        counter++;
      }
      if (data.documents.length) {
        params = params.append(`conditions[${counter}].fieldName`, "lovId");
        params = params.append(`conditions[${counter}].value`, data.documents[0]);
        params = params.append(`conditions[${counter}].operator`, "EQUALS");
        counter++;
      }
      if (data.subDirection.length) {
        params = params.append(`conditions[${counter}].fieldName`, "subDirection");
        params = params.append(`conditions[${counter}].value`, data.subDirection[0]);
        params = params.append(`conditions[${counter}].operator`, "CONTAINS");
        counter++;
      }

      if (data.controlDate && data.controlDate.length) {
        const datepipe: DatePipe = new DatePipe("en-US");
        let formattedDate = datepipe.transform(new Date(data.controlDate[0]), "YYYY-MM-dd");
        params = params.append(`conditions[${counter}].fieldName`, "controlDate");
        params = params.append(`conditions[${counter}].value`, formattedDate || "");
        params = params.append(`conditions[${counter}].operator`, "GREATER_THAN_EQUALS");
        counter++;

        formattedDate = datepipe.transform(new Date(data.controlDate[1]), "YYYY-MM-dd");
        params = params.append(`conditions[${counter}].fieldName`, "controlDate");
        params = params.append(`conditions[${counter}].value`, formattedDate || "");
        params = params.append(`conditions[${counter}].operator`, "LESS_THAN_EQUALS");
        counter++;
      }
    },
    );
    subscriber.unsubscribe();
    return params;
  }

  allowDateEditing(row: any) {
    this.dateEditing = {};
    this.editingGoodsLovControlDateDto = {} as GoodsLovControlDateDto;
    this.editingGoodsLovControlDateDto.lovId = row.lovId;
    this.editingGoodsLovControlDateDto.controlDate = row.controlDate;
    console.log(this.editingGoodsLovControlDateDto);
    // @ts-ignore
    this.dateEditing[row.id] = true;
  }

  isDatEditingAllowed(id: number): boolean {
    // @ts-ignore
    return !!this.dateEditing[id];
  }

  approveLovIdDataChanging(row: any) {
    this.reserveController.updateDateForLovIds(this.editingGoodsLovControlDateDto).subscribe(data => {
      this.notificationService.success(data["message"]);
      // @ts-ignore
      delete this.dateEditing[row.id];
      row.controlDate = this.editingGoodsLovControlDateDto.controlDate;
      this.editingGoodsLovControlDateDto = {} as GoodsLovControlDateDto;
    });

  }

  cancelLovIdDataChanging(row: any) {
    // @ts-ignore
    delete this.dateEditing[row.id];
  }
}

export const tabHeaderReserves = [
  { key: "1", style: "", label: "LOV ID", date: false, filter: true, enum: false,  joinTable: "" },
  { key: "2", style: "", label: "MHH ID", date: false, filter: true, enum: true, joinTable: "" },
  { key: "3", style: "", label: "Напрям", date: false, filter: true, enum: true, joinTable: "goods" },
  { key: "4", style: "", label: "MHH", date: false, filter: true, enum: false, joinTable: "goods" },
  { key: "5", style: "", label: "Дозування", date: false, filter: true, enum: false, joinTable: "goods" },
  { key: "6", style: "", label: "Одиниця виміру", date: true, filter: true, enum: false, joinTable: "" },
  { key: "7", style: "", label: "Відмова", date: true, filter: true, enum: false, joinTable: "" },
  { key: "8", style: "", label: "Доступно для розподілу", date: false, filter: true, enum: false, joinTable: "" },
  { key: "9", style: "", label: "Наказ/Відмова", date: false, filter: true, enum: false, joinTable: "" },
  { key: "10", style: "", label: "Піднапрям", date: false, filter: true, enum: false, joinTable: "" },
  { key: "11", style: "", label: "Контрольна дата", date: false, filter: true, enum: false, joinTable: "" },
];

export const tabHeaderReservesSpecifications = [
  { key: "1", label: "МНН", date: false, filter: true, enum: false,  joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: false },
  { key: "2", label: "Дозування", date: false, filter: true, enum: false, joinTable: "", showChevron: true, chevronOpen: false, hideAbleColumn: false  },
  { key: "3", label: "Доступно до розподілу", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: true  },
  { key: "4", label: "MHH ID", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: true  },
  { key: "5", label: "LOV ID", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: true  },
  { key: "6", label: "Напрям", date: true, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: true  },
  { key: "7", label: "Одиниця виміру", date: true, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: true  },
  { key: "8", label: "Наказ/Відмова", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: true  },
  { key: "9", label: "Піднапрям", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: true  },
  { key: "10", label: "Серія/Каталожній номер", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: false  },
  { key: "11", label: "Торгова назва", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: false  },
  { key: "12", label: "Кратність", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: false  },
  { key: "13", label: "Кількість", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: false  },
  { key: "14", label: "Вартість за одиницю, грн", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: false  },
  { key: "15", label: "Загальна вартість, грн", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: false  },
  { key: "16", label: "Номер договору", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: false  },
  { key: "17", label: "Термін придатності", date: false, filter: true, enum: false, joinTable: "", showChevron: true, chevronOpen: false, hideAbleColumn: false  },
  { key: "18", label: "Виробник", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: true  },
  { key: "19", label: "Країна виробника", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: true  },
  { key: "20", label: "Країна походження", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: true  },
  { key: "21", label: "Дата виробництва", date: false, filter: true, enum: false, joinTable: "", showChevron: false, chevronOpen: false, hideAbleColumn: true  },
];
